import React, { ReactElement } from 'react';
import {
  formatHcpDetails,
  getDiscountForReferralCoupon,
  getFreeTrialSearchParamIsTrue,
  getHcpDetailsFromUrl,
} from '../../config/AssessmentUtils';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { ScreenWrapper } from '../styles/Containers';
import { NavigationProps } from './FlowNavigation';
import {
  PresentationContent,
  PresentationLayout,
  PresentationLayoutConfig,
} from './layouts/PresentationLayout';

export type HcpReferredScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.HcpReferred,
  PresentationLayoutConfig,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  HcpReferredScreenConfig<ScreenNames>,
  ScreenNames
>;

export const HcpReferredScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  function handlePrimaryButtonPress() {
    props.navigation.next(props);
  }

  const hcpDetails = formatHcpDetails(getHcpDetailsFromUrl());
  const hasFreeTrial = getFreeTrialSearchParamIsTrue();
  const discount = getDiscountForReferralCoupon();

  function replaceTextContentKeys(presentationContent: PresentationContent) {
    return presentationContent.type === 'text'
      ? {
          ...presentationContent,
          content: presentationContent.content
            .replace('{{hcpDetails}}', hcpDetails)
            .replace('{{freeTrial}}', hasFreeTrial ? 'and a 7-day free trial' : '')
            .replace('{{discount}}', discount ?? ''),
        }
      : presentationContent;
  }

  return (
    <ScreenWrapper>
      <PresentationLayout
        onPressPrimaryButton={handlePrimaryButtonPress}
        {...props.layout}
        content={props.layout.content.map(replaceTextContentKeys)}
      />
    </ScreenWrapper>
  );
};
